import styles from './FilterCompanyMobile.module.css'
import arrowLeft from '../../assets/icons/arrowLeft.svg'
import { useState } from 'react'
import CustomButton from '../UI/CustomButton/CustomButton'
import { CompaniesType } from '../../redux/actions/types'

interface Props {
  onClickHandler: () => void
  closeFilter: () => void
  companies?: CompaniesType[]
  companiesReports?: { value: number | string; label: string }[]
  setUserFilter: React.Dispatch<React.SetStateAction<string>>
}

const FilterCompanyMobile: React.FC<Props> = ({
  onClickHandler,
  companies,
  setUserFilter,
  closeFilter,
  companiesReports,
}) => {
  const [selected, setSelected] = useState<string>('')

  return (
    <div className={styles.filterContainer}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <img onClick={onClickHandler} src={arrowLeft} alt='Back' />
          <div>Компании</div>
        </div>
        <div className={styles.content}>
          {companies &&
            companies?.map((item: any) => (
              <div
                onClick={() => setSelected(item.name)}
                className={
                  selected === item.name
                    ? `${styles.active} ${styles.contentItem}`
                    : styles.contentItem
                }
                key={item.id}
              >
                {item.name}
              </div>
            ))}
          {companiesReports &&
            companiesReports?.map((item: any) => (
              <div
                onClick={() => setSelected(item.value)}
                className={
                  selected === item.value
                    ? `${styles.active} ${styles.contentItem}`
                    : styles.contentItem
                }
                key={item.id}
              >
                {item.label}
              </div>
            ))}
        </div>
      </div>
      <div className={styles.footerContainer}>
        <CustomButton
          title='Применить'
          className={styles.filtersBtn}
          type='button'
          onClick={() => {
            setUserFilter(selected)
            onClickHandler()
            closeFilter()
          }}
        />
      </div>
    </div>
  )
}

export default FilterCompanyMobile
